import React, { useRef } from 'react';
import { Row } from 'react-table';

import { ROUTE } from '~/app/routes';
import { PageHeader, PaginationWrapper, PaginationWrapperRefProps, Section } from '~/components';
import { useNavigate } from '~/lib/navigation';
import { CardTransactionRepository, ListCardTransactionsParams } from '~/repositories/CardTransactionRepository';
import { Inner } from '~/styles';

import { CardTransactionRow, cardTransactionColumns, mapCardTransactionRow } from './shared';

export const PageCardTransactionsOverview: React.FC = () => {
  const navigate = useNavigate();
  const paginationRef = useRef<PaginationWrapperRefProps>(null);

  const handleFetch = async (params: ListCardTransactionsParams) => {
    return CardTransactionRepository.listCardTransactions(params).then((response) => ({
      entries: response.cardTransactions.map(mapCardTransactionRow),
      hasMore: Boolean(response.hasMore),
    }));
  };

  return (
    <>
      <PageHeader text="Card Transactions" border={false} />
      <Inner p={0}>
        <Section headline="Transactions">
          <PaginationWrapper
            tableId="card-transactions"
            fetch={handleFetch}
            columns={cardTransactionColumns}
            ref={paginationRef}
            rowClick={(row: Row<CardTransactionRow>) => {
              navigate(`${ROUTE.CARD_TRANSACTIONS}/edit/${row.original.id}`);
            }}
          />
        </Section>
      </Inner>
    </>
  );
};
